<div class="info-options">
	@let option = optionContract();
	@if (option) {
		<div class="option-title">
			<span [tuiSkeleton]="isLoading()">{{ option?.underlying_asset?.ticker ?? '-' }}</span>
			<span [tuiSkeleton]="isLoading()">{{ option?.details?.strike_price | price }}</span>
			<span
				[tuiSkeleton]="isLoading()"
				highlight
				[isPositive]="option?.details?.contract_type === optionTypeEnum.CALL"
				[isNegative]="option?.details?.contract_type === optionTypeEnum.PUT"
				>{{ option?.details?.contract_type | uppercase }}</span
			>
			<span [tuiSkeleton]="isLoading()">{{ option?.details?.expiration_date | date: 'dd.MM.yyyy' }}</span>
		</div>

		<div class="order-book">
			<app-order-book
				[orderBook]="orderBook()"
				viewType="diagrammatic"
				[isExpanded]="false"
				[isLoading]="isLoading()"
			/>
		</div>

		<h4
			class="headline"
			[tuiSkeleton]="isLoading()"
		>
			{{ 'infoOptions.statistics.statistics' | translate }}
		</h4>
		<div class="statistic">
			<div class="wrapper">
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.avgPrice' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.day?.vwap ?? 0 | price"
					></span>
				</div>
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.openPrice' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.day?.open ?? 0 | price"
					></span>
				</div>
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.closePrice' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.day?.close ?? 0 | price"
					></span>
				</div>
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.beforeClose' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.day?.previous_close ?? 0 | price"
					></span>
				</div>
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.lastTrade' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.last_trade?.price ?? 0 | price"
					></span>
				</div>
			</div>
			<div class="wrapper">
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.maxDay' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.day?.high ?? 0 | price"
					></span>
				</div>
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.minDay' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.day?.low ?? 0 | price"
					></span>
				</div>
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.openInterest' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.open_interest ?? 0 | quantity"
					></span>
				</div>
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.implVolatility' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.implied_volatility ?? 0 | price: false"
					></span>
				</div>
				<div class="item">
					<span
						class="title"
						[tuiSkeleton]="isLoading()"
						>{{ 'infoOptions.statistics.volumePerDay' | translate }}</span
					>
					<span
						class="value"
						[tuiSkeleton]="isLoading()"
						[appAnimatedNumber]="option?.day?.volume ?? 0"
					></span>
				</div>
			</div>
		</div>

		<h4
			class="headline"
			[tuiSkeleton]="isLoading()"
		>
			{{ 'infoOptions.greek.greek' | translate }}
		</h4>
		<div class="greek">
			<div class="wrapper">
				<div class="inner">
					<div class="item">
						<span
							class="title"
							[tuiSkeleton]="isLoading()"
							>{{ 'infoOptions.greek.delta' | translate }}</span
						>
						<span
							class="value"
							[tuiSkeleton]="isLoading()"
							[appAnimatedNumber]="option?.greeks?.delta | price: false"
						></span>
					</div>
					<div class="item">
						<span
							class="title"
							[tuiSkeleton]="isLoading()"
							>{{ 'infoOptions.greek.theta' | translate }}</span
						>
						<span
							class="value"
							[tuiSkeleton]="isLoading()"
							[appAnimatedNumber]="option?.greeks?.theta | price: false"
						></span>
					</div>
				</div>
				<div class="inner">
					<div class="item">
						<span
							class="title"
							[tuiSkeleton]="isLoading()"
							>{{ 'infoOptions.greek.gamma' | translate }}</span
						>
						<span
							class="value"
							[tuiSkeleton]="isLoading()"
							[appAnimatedNumber]="option?.greeks?.gamma | price: false"
						></span>
					</div>
					<div class="item">
						<span
							class="title"
							[tuiSkeleton]="isLoading()"
							>{{ 'infoOptions.greek.vega' | translate }}</span
						>
						<span
							class="value"
							[tuiSkeleton]="isLoading()"
							[appAnimatedNumber]="option?.greeks?.vega | price: false"
						></span>
					</div>
				</div>
			</div>
			<span
				class="description"
				[tuiSkeleton]="isLoading()"
				>{{ 'infoOptions.description' | translate }}</span
			>
		</div>
	} @else {
		<div class="not-have-option">
			<app-empty-table textPath="infoOptions.notHaveOption" />
		</div>
	}
</div>
